module.exports = __webpack_public_path__ + "img/hammam_Palma.59f5811b.jpg";